import React from "react";
import './About_Banner.css'
import { IDS } from '../../../utils/IDS';
const About_Banner = ({ Image }) => {


  return (
    <section className="About_Banner">
      <div className="container">
        <div className="banner_div">
          <img
            src={`${IDS.IMG_URL + Image}`
            }
            alt="About Us Image" className="banner_img"
          />

        </div>
      </div>
    </section>
  );
};

export default About_Banner;
